import { Flex, Heading, RectangularButton } from '@resideo/blueprint-react';
import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { screenBreakpoints } from 'hooks/useMedia';

const containerSharedStyle = css`
  flex-direction: column;
  background-color: rgb(247 247 247);
  max-width: 320px;
  height: calc(100vh - 80px);
  justify-content: flex-end;
  box-sizing: border-box;
`;

export const LeftNavContainer = styled(Flex)`
  width: 320px;

  ${containerSharedStyle}
`;

export const MobileLeftNavContainer = styled(Flex)<{ isOpen?: boolean }>`
  z-index: var(--zidx-left-nav);
  position: absolute;
  overflow: hidden;
  height: 100%;
  transition: 300ms;
  width: ${({ isOpen }) => (isOpen ? '80%' : '0%')};
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);

  ${containerSharedStyle}
`;

export const StyledLink = styled(NavLink)`
  text-decoration: none;
  color: #000000;
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  padding: 0.5rem 0;
  padding-left: ${({ theme }) => theme.space.large};
`;

export const NavList = styled.ul`
  position: absolute;
  top: 0;
  left: 0;
  list-style: none;
  padding: 0;
  width: 320px;
  height: 100%;
  margin-bottom: auto;
  margin-top: 48px;
  .active {
    background: rgb(227 227 227);
    font-weight: bold;
  }
`;

export const NavSublist = styled.ul`
  list-style: none;
  padding: 0;
  a {
    padding-left: ${({ theme }) => theme.space.xLarge};
  }
`;

export const NavHeader = styled(Heading)`
  font-size: ${({ theme }) => theme.fontSizes.xxLarge};
  font-weight: bold;
  padding-left: ${({ theme }) => theme.space.large};
  padding-bottom: 1.5rem;
  cursor: pointer;
  display: block;
  text-decoration: none;
  color: black;
  letter-spacing: 1px;
`;

export const Summary = styled.summary`
  &::marker {
    display: none !important;
    content: '';
  }
`;

export const SignOutButton = styled(RectangularButton)`
  min-width: 280px;
  width: calc(100% - 2rem);
  align-self: center;
  margin-bottom: 1rem;

  @media screen and (min-width: ${screenBreakpoints.md}) {
    display: none;
  }
`;
